import React from 'react';

import PropTypes from 'prop-types';
import {Form, FormikProps} from 'formik';
import {CallMade} from '@material-ui/icons';
import {useHistory} from 'react-router-dom';
import {AppBar, Box, Grid} from '@material-ui/core';

import {EfeAccordion, EfeButtonPrimary, EfeFormSection, EfeSupportMessage} from 'components';
import {TransactionalProfileServiceRequest, EfeAccordionValues} from 'commons/models';
import {useSpinner} from 'hooks';
import {FieldShape} from 'commons/shapes';
import {MainContent} from 'layouts/commons';
import {AppBarStyles} from 'assets/tss/commons';
import {InferPropTypes} from 'commons/types/Types';
import {ReactComponent as ActionIcon} from 'assets/icons/section/action/edit.svg';
import {HistoryRoutes} from 'commons/constants';

InnerFormProfileInfo.propTypes = {
    title: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape(FieldShape).isRequired).isRequired,
};

function InnerFormProfileInfo(
    props: InferPropTypes<
        typeof InnerFormProfileInfo.propTypes & FormikProps<TransactionalProfileServiceRequest>
    >
) {
    const {values, errors, isLoading, fields, isSubmitting, setFieldValue, title} = props;

    const history = useHistory();
    const classes = AppBarStyles();

    const accordion: Array<EfeAccordionValues> = [
        {
            icon: <ActionIcon />,
            title: title,
            reactElement: (
                <Box m={2}>
                    <EfeSupportMessage />
                    <EfeFormSection
                        fields={fields}
                        values={values}
                        errors={errors}
                        setFieldValue={setFieldValue}
                    />
                </Box>
            ),
            expandIcon: true,
            disabled: false,
            expanded: true,
        },
    ];

    /* eslint-disable react/jsx-handler-names */
    return (
        <Form noValidate>
            <Box mt={8}>
                {useSpinner(isLoading)}

                {fields && fields.length > 0 ? (
                    <EfeAccordion
                        onChange={() => history.push(HistoryRoutes.TRANSACTIONAL_PROFILE)}
                        values={accordion}
                    />
                ) : null}
            </Box>
            <AppBar position='fixed' color='primary' className={classes.appBar}>
                <MainContent>
                    <Grid container direction='row' justifyContent='flex-start'>
                        <Box m={2}>
                            <EfeButtonPrimary
                                fullWidth
                                disabled={isSubmitting}
                                type='submit'
                                endIcon={<CallMade />}>
                                {'Guardar y Continuar'}
                            </EfeButtonPrimary>
                        </Box>
                    </Grid>
                </MainContent>
            </AppBar>
        </Form>
    );
}

export default InnerFormProfileInfo;
